module.exports = __webpack_public_path__ + "static/img/contactUsBg-p.7ca0815.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/contactUsBg-p.png
// module id = wxUH
// module chunks = 1